<template>
    <div>
        <step-navigation
                :steps="steps"
                :currentstep="step"
                @step-change="stepChanged"
                v-if="header == true">
        </step-navigation>
        <div v-for="(pivote, index) in steps" :key="index">
            <div class="step-content" v-if="index + 1 === step">
                <slot :name="'content-' + (index+1)"></slot>
            </div>
        </div>
        <step-controls
                v-for="nodo in steps"
                :key="nodo.id"
                :step="nodo"
                :showControl="showControl"
                :stepcount="steps.length"
                :currentstep="step"
                @step-change="stepChanged"
                @step-save="callback">
        </step-controls>
    </div>
</template>

<script>
    import StepNavigation from "./step/step-navigation";
    import StepControls from "./step/step-controls";

    export default {
        props: {
            steps: {type: Array, default: () => ([])},
            callback: {type: Function, default: () => true},
            value: {type: Number, default: 0},
            header: {type: Boolean, default: true},
            showControl: {type: Boolean, default: true}
        },
        data() {
            return {
                step: 1
            }
        },
        watch: {
            value(value) {
                this.step = value;
            }
        },
        mounted() {
            if (this.value) {
                this.step = this.value;
            }
        },
        name: "v-step",
        components: {StepControls, StepNavigation},
        methods: {
            stepChanged(step) {
                //this.step = step;
                //window.scrollTo(0,0);
                //this.handleInput();
                this.$emit('step', step)
            },
            handleInput() {
                this.$emit('input', this.step)
            }
        }
    }
</script>

<style scoped>

</style>
